import { VueExtension } from '../../utils/extensions/vue';
import Catalog from './catalog.vue';
import './catalog.scss';

VueExtension.WithInstall(Catalog);

export default Catalog;
